<!-- FILE GENERATED BY packages/components/design-tokens/build-scripts/generate-icons.js DO NOT CHANGE -->

<svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    data-token-name="IconShield_16"
    viewBox="0 0 16 16"
    aria-hidden="true"
>
    <path
        fill="currentColor"
        fill-rule="evenodd"
        d="M3.584 12.209C4.64 13.66 5.978 14.592 7.6 15c1.622-.408 2.96-1.339 4.016-2.791C12.672 10.756 13.2 9.143 13.2 7.37V3.1L7.6 1 2 3.1v4.27c0 1.773.528 3.386 1.584 4.839Zm6.332-6.091a.402.402 0 1 1 .569.569L7.289 9.882a.402.402 0 0 1-.57 0L5.119 8.28a.402.402 0 1 1 .569-.569L7.004 9.03l2.912-2.911Z"
        clip-rule="evenodd"
    />
</svg>
